import database from "../../../services/database";
import IconButton from "../../../components/icon-button";
import React from "react";
import SEO from "../../../components/SEO";

function Home() {
    return (
        <>
            <SEO 
                title="Próteses"
                description="Próteses sob medida: mama, membros superiores (ombro, cotovelo, punho, mãos e dedos, braço, antebraço) e membros inferiores (quadril, joelho, acima e abaixo do joelho)."
                keywords="próteses, prótese sob medida, prótese de mama, prótese de perna, prótese de braço, prótese joelho, prótese quadril"
                canonicalUrl="https://www.saojoseortopedicos.com.br/produtos/proteses"
            />
            <h2>{database.proteses.title}</h2>
            <p>
                {database.proteses.description}
            </p>
            {
                database.proteses.items.map(x => {
                    return (
                        <>
                            <h3>{x.title}</h3>
                            <ul className="icones">
                                {
                                    x.items.map(y => {
                                        return (
                                            <li>
                                                <IconButton
                                                    title={y.title}
                                                    icon={y.icon}
                                                    path={y.path}
                                                    iconLegend={y.iconLegend}
                                                />
                                            </li>
                                        );
                                    })
                                }
                            </ul>
                        </>
                    )
                })
            }
        </>
    );
}

export default Home;